import React from "react";
import { withRouter } from "react-router";
import DebugFilter from "./DebugFilter";
import UpdatesFilter from "./UpdatesFilter";
import AboutTitle from "./AboutTitle";
import AceTitle from "./AceTitle";
import DoremiTitle from "./DoremiTitle";
import KoryuTitle from "./KoryuTitle";
import Mickey3Title from "./Mickey3Title";
import MiracleTitle from "./MiracleTitle";
import UndercoverTitle from "./UndercoverTitle";

//get the current route, and display any required filters
class CheckRouteAndShowFilter extends React.Component {
  constructor(state, props) {
    super(state, props);
    this.state = {
      search: "all",
      route: this.props.route,
      debug: ""
    };
  }

  //pass the news search value back to parent
  onChangeSearch = value => {
    this.setState({ search: value });
    this.props.onChangeSearch(value);
  };

  //pass the debug search value back to parent
  onChangeDebug = value => {
    //this.setState({ debug: value });	//dont store the value
    //this.props.onChangeDebug(value);
  };

  onChangeRoute = value => {
    this.setState({ route: value });
    this.props.onChangeRoute(value);
  };

  componentWillReceiveProps(nextProps) {
    if (this.state.route !== nextProps.location.pathname) {
      this.setState({ route: nextProps.location.pathname });
      this.props.onChangeRoute(nextProps.location.pathname);
    }
  }

  render() {
    return (
      <div>
        {this.props.route === "/" ? (
          <UpdatesFilter
            search={this.state.search}
            onChangeSearch={this.onChangeSearch}
          />
        ) : null}
        {this.props.route === "/about" ? <AboutTitle /> : null}
        {this.props.route === "/ace" ? <AceTitle /> : null}
        {this.props.route === "/doremi" ? <DoremiTitle /> : null}
        {this.props.route === "/koryu" ? <KoryuTitle /> : null}
        {this.props.route === "/mickey3" ? <Mickey3Title /> : null}
        {this.props.route === "/miracle" ? <MiracleTitle /> : null}
        {this.props.route === "/debug" ? (
          <DebugFilter
            debug={this.state.debug}
            onChangeDebug={this.onChangeDebug}
          />
        ) : null}
        {this.props.route === "/undercover" ? <UndercoverTitle /> : null}
      </div>
    );
  }
}

export default withRouter(CheckRouteAndShowFilter);



// WEBPACK FOOTER //
// ./src/lib/CheckRouteAndShowFilter.js